import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Dropdown, DropdownAnchor, DropdownContent } from '@fiverr-private/dropdown';
import { user, abTests, rollouts } from '../../../../PropTypes';
import { DropdownTriggerButton } from '../../../DropdownTriggerButton';
import { getBQData } from '../../../../utils/business/bi-utils';
import { reportMixpanelClick } from '../../../../utils/reporter';
import { DefaultMenu } from './DefaultMenu';

const T_PREFIX = 'header.fiverr_pro_entry';

interface ProDropdownProps {
    isTransparent: boolean;
    onOpen: () => void;
}

export const ProDropdown: React.FC<ProDropdownProps> = ({ isTransparent, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            reportMixpanelClick({
                eventName: 'Fiverr logged-out header - Pro - Clicked',
            });
        }
    }, [isOpen]);

    const onMenuOpen = () => {
        if (!isOpen) {
            onOpen?.();
        }

        setIsOpen(!isOpen);
    };

    return (
        <Dropdown position="bottom-end" isOpen={isOpen} onOpenChanged={onMenuOpen}>
            <DropdownAnchor embed>
                <DropdownTriggerButton
                    title={<I18n k={`${T_PREFIX}.title`} />}
                    bigQueryData={getBQData({
                        type: 'open_menu_fiverr_pro',
                        component: { name: 'Header' },
                    })}
                    isOpen={isOpen}
                    onClick={onMenuOpen}
                    isTransparent={isTransparent}
                />
            </DropdownAnchor>
            <DropdownContent closeOnClickOutside>
                <DefaultMenu />
            </DropdownContent>
        </Dropdown>
    );
};

ProDropdown.propTypes = {
    isTransparent: bool.isRequired,
    onOpen: func.isRequired,
};

ProDropdown.contextTypes = {
    abTests,
    user,
    rollouts,
};
